// @ts-generator-hash: 8a680776d2be28f188b8280b4a5e86fd672c9585e46cdaf557e0981cb16625ef
// Generation date: 2/2/2026 8:19:01 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.TrackedMode
export enum TrackedMode {
  Manual = 0,
  NoOverlap = 1,
  EndDateOnly = 2,
}
